import { Link } from 'react-router-dom';

/**
 * 內頁返回 chevron — 左側「‹」線條箭頭連結。
 *
 * 對齊 `docs/Boat_Ticket_PWA.pen` 設計稿之內頁 topbar（product / buy / checkout）：
 * topbar 左側為 chevron + 標題，右側無元素。
 */
export function BackChevron({ to, label }: { to: string; label: string }): JSX.Element {
  return (
    <Link to={to} className="topbar-chevron" aria-label={label}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </Link>
  );
}
